import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { useViewportMediaQuery } from 'hooks'
import CustomSelect from "components/CustomSelect";
import TagManagerService from 'services/TagManager'
import style from './style.scss';//NOSONAR

const SortBySelector = (props) => {
    const { options, callback, defaultOption, itemId } = props

    
    const [selectedValue, setSelectedValue] = useState(defaultOption)
    const [isSideOptionsOpen, setIsSideOptionsOpen] = useState(false)
    const isMobile = useViewportMediaQuery(1024)

    const selectOption = (value) => {
        setSelectedValue(value)
        callback(value)
        setIsSideOptionsOpen(false)
        TagManagerService.interaction(`Sorting: ${value.label}`, itemId,  'PDP -Reviews');
    }

    return (
        <div className="sort-by">
            {isMobile && (
                <>
                    <div className={`sort-by-overlay ${isSideOptionsOpen && 'is-open'}`} onClick={() => setIsSideOptionsOpen(false)} />
                    <div className={`sort-by-mobile-options ${isSideOptionsOpen && 'is-open'}`}>
                        <div className="sort-by-mobile-options-title">
                            Ordenar <i className="order-icon-mobile jumbo-icon-replacement" />
                        </div>
                        {options.map((opt, index) => {
                            return (
                                <label key={index} className="sort-by-option">
                                    <div className="sort-by-checkbox ">
                                        <input 
                                            type="checkbox"
                                            className='product-on-list-checked'
                                            checked={selectedValue.label === opt.label} 
                                            onChange={() => selectOption(opt)}
                                        />
                                        {opt.label}
                                    </div>
                                </label>
                            )
                        })}
                    </div> 
                </>
            )}

            <div className="sort-by-button" onClick={isMobile ? () => setIsSideOptionsOpen(true) : null}>
                Ordenar {isMobile ? (
                    <i className='jumbo-icon-replacement' />
                ) : (
                    <>
                        por
                        <CustomSelect
                            options={options}
                            onChange={selectOption}
                            value={selectedValue}
                            placeholder={selectedValue.label}
                        />
                    </>
                )}
            </div> 
            
        </div>
    )  
}

SortBySelector.propTypes = {
    options: PropTypes.array,
    callback: PropTypes.func,
    defaultOption: PropTypes.object,
    itemId : PropTypes.string
}

export default SortBySelector